import React from 'react';

const RemoteApps = props => (
  <div className="layout u-mt+">
    {
      Object.values(props.remotes).map((remote) => (
        <div key={remote.name} className="layout__item u-ph+">
          <div className="c-label-new">{remote.humanReadableName}</div>
          <input
            className="c-input"
            value={remote.url}
            onChange={(e) => props.updateRemoteUrl(remote.name, e.target.value)}
          />
        </div>
      ))
    }
    <div className="layout__item u-text-right u-pr+">
      <button className="c-btn" onClick={props.saveRemotes}>Save remotes</button>
    </div>
  </div>
);

export default RemoteApps;
